export default __webpack_public_path__ + "static/media/hamburguesa.06719392.svg";